export const CONTACT = {
  whatsapp: "593998591152", // VORNA WhatsApp Business: +593 99 859 1152
  instagram: "https://instagram.com/vorna.fightwear",
  facebook: "https://facebook.com/vorna",
  tiktok: "https://tiktok.com/@vorna",
  email: "vornaec@gmail.com",
  city: "Quito, Ecuador",
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
